import { render, staticRenderFns } from "./AccountTransactionList.vue?vue&type=template&id=3245ad08&scoped=true"
import script from "./AccountTransactionList.vue?vue&type=script&lang=js"
export * from "./AccountTransactionList.vue?vue&type=script&lang=js"
import style0 from "./AccountTransactionList.vue?vue&type=style&index=0&id=3245ad08&prod&lang=scss&scoped=true"
import style1 from "./AccountTransactionList.vue?vue&type=style&index=1&id=3245ad08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3245ad08",
  null
  
)

export default component.exports